/**
 * I18n
 */

import fr from '@shared/i18n/fr';

enum Locales {
  EN = 'en',
  FR = 'fr',
}

type MessageSchema = typeof fr;

type I18nMessage = { message: MessageSchema };

export { Locales, MessageSchema, I18nMessage };
